import { useQuery } from "react-query";
import { getUser } from "../api/user/getUser";

export const USER_DETAILS_QUERY_KEY = ["user-details"];
export const useQueryGetUser = () => useQuery(USER_DETAILS_QUERY_KEY, getUser);
